<template>

  <div id="page-user-list">
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="pagidropdown border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ ratingData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : ratingData.length }} of {{ ratingData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          From: &nbsp; <vs-input class="receiptDateSearch" type="date" v-model="searchQueryDateFrom" /> &nbsp;&nbsp;
          To: &nbsp; <vs-input class="receiptDateSearch" type="date" v-model="searchQueryDateTo" /> &nbsp;&nbsp;
          <vs-input class="teacherSearchBtn sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search by Instructor / Lesson / Student..." />

          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
          <input type="checkbox" name="is_complaint" value="1" style="margin-right: 7px;" v-on:click="searchQueryIsComplaint($event)" /> Show Complaints

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="ratingData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />
      
        <h4>Overall rating</h4>
        <br>
        <b>Explanation of the exercise: {{ ratings1 }}</b>
        <br>
        <b>Assistens from the instructor: {{ ratings2 }}</b>
        <br>
        <b>Overall experience: {{ ratings3 }}</b>

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleSlipperyRatingManagement from '@/store/slippery-rating/moduleSlipperyRatingManagement.js'

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue"
import CellRendererStudent from "./cell-renderer/CellRendererStudent.vue"
import CellRendererDate from "./cell-renderer/CellRendererDate.vue"
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStudent,
    CellRendererDate,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {

      data_local : {
        from_date : '',
        to_date : ''
      },
      ratings1: 0,
      ratings2: 0,
      ratings3: 0,

      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' },
      ],
      searchQueryDateFrom: '',
      searchQueryDateTo: '', 

      statusFilter: { label: 'Status - All', value: 'all' },
      statusOptions: [
        { label: 'Status - All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' },
      ],

      isVerifiedFilter: { label: 'Email - All', value: 'all' },
      isVerifiedOptions: [
        { label: 'Email - All', value: 'all' },
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 },
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' },
      ],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        filterable: false,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          filter: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: false,
        },
        {
          headerName: 'Instructor',
          field: 'teacher.name',
          filter: false,
          width: 300,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Student',
          field: 'student.name',
          filter: false,
          width: 300,
          cellRendererFramework: 'CellRendererStudent'
        },
        {
          headerName: 'Review',
          field: 'review',
          filter: false,
          width: 300,
        },
        {
          headerName: 'Explanation of the exercise',
          field: 'rating1',
          filter: false,
          width: 270,
        },
        {
          headerName: 'Assistens from the instructor',
          field: 'rating2',
          filter: false,
          width: 270,
        },
        {
          headerName: 'Overall experience',
          field: 'rating3',
          filter: false,
          width: 190,
        },
        {
          headerName: 'Date',
          field: 'created_at',
          width: 300,
          cellRendererFramework: 'CellRendererDate'
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererDate,
        CellRendererVerified,
        CellRendererActions,
      }
    }
  },
  watch: {
    searchQueryDateFrom(obj) {
      let searchData = this.data_local
      searchData.from_date = obj;
      this.$store.dispatch("slipperyratingManagement/searchTheoryRating", searchData).catch(err => { console.error(err) })
    },
    searchQueryDateTo(obj) {
      let searchData = this.data_local
      searchData.to_date = obj;
      this.$store.dispatch("slipperyratingManagement/searchTheoryRating", searchData).catch(err => { console.error(err) })
    },
  },
  computed: {
    ratingData() {
      return this.$store.state.slipperyratingManagement.ratings
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }
      this.searchQueryDateFrom = ''
      this.searchQueryDateTo = ''

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    searchQueryIsComplaint(event) {
      if (event.target.checked)
      {
        console.log('complaints');
        this.$store.dispatch("slipperyratingManagement/fetchRatings", {
          is_complaint: 1
        }).catch(err => { console.error(err) })
      }
      else
      {
        console.log('No complaints');
        this.$store.dispatch("slipperyratingManagement/fetchRatings").catch(err => { console.error(err) })
      }
      
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if(!moduleSlipperyRatingManagement.isRegistered) {
        console.log('is registered not');
      this.$store.registerModule('slipperyratingManagement', moduleSlipperyRatingManagement)
      moduleSlipperyRatingManagement.isRegistered = true
    }
    this.$store.dispatch("slipperyratingManagement/fetchRatings").catch(err => { console.error(err) })

    this.$store.dispatch("slipperyratingManagement/fetchRating1Avg")
      .then(res => { this.ratings1 = res.data })
      .catch(err => {
        
        console.error(err) }
    )

    this.$store.dispatch("slipperyratingManagement/fetchRating2Avg")
      .then(res => { this.ratings2 = res.data })
      .catch(err => {
        
        console.error(err) }
    )

    this.$store.dispatch("slipperyratingManagement/fetchRating3Avg")
      .then(res => { this.ratings3 = res.data })
      .catch(err => {
        
        console.error(err) }
    )
  }
}

</script>



<style type="text/css">

.pagidropdown{
    padding: 11px!important;
}

.rounded-full {
    border-radius: 7px !important;
}

.teacherSearchBtn{
  width: 34% ! important;
}

.teacherSearchStatus{
  width: 17% ! important;
}

.teacherSearchEmail{
  width: 17% ! important;
}
</style>